module.exports = __webpack_public_path__ + "static/media/VectorCancel.250bdc25.svg";